<mat-form-field>
    <label for="search" *ngIf="showLabel && placeholder">{{ placeholder }}</label>
    <input
        #inputField
        matInput
        type="text"
        [placeholder]="!showLabel && placeholder"
        [matAutocomplete]="autoTemplate"
        [formControl]="formControl"
        tabindex="0"
        (focusout)="onInputFocusOut()"
        (keyup.enter)="confirmOption()"
    />
    <mat-icon *ngIf="showDropdownIcon && !loading" matSuffix class="suffix-dropdown-icon">keyboard_arrow_down</mat-icon>
    <mat-spinner *ngIf="loading" matSuffix [diameter]="20" class="suffix-loading-spinner"></mat-spinner>

    <mat-autocomplete
        #autoTemplate
        [displayWith]="displayFn"
        (optionSelected)="onSelect($event)"
        [autoActiveFirstOption]="true"
        (opened)="onAutocompleteOpened()"
    >
        <mat-option *ngFor="let result of results$ | async" [value]="result">
            <div>
                {{ result?.label || result.id }}
            </div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
